var React = require('react');

function User2Light (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M42 46H6a1 1 0 01-1-1 19 19 0 1138 0 1 1 0 01-1 1zM7 44h33.94A17 17 0 007 44z","key":0}),React.createElement("path",{"d":"M24 25A12 12 0 1124 .999 12 12 0 0124 25zm0-22a10 10 0 100 20 10 10 0 000-20z","key":1}),React.createElement("path",{"d":"M27.68 14a19.36 19.36 0 01-13.85-5.89 1 1 0 011.44-1.39A17.35 17.35 0 0027.68 12c2.349 0 4.673-.48 6.83-1.41a1 1 0 11.79 1.84A19.18 19.18 0 0127.68 14z","key":2})]);
}

User2Light.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = User2Light;

User2Light.default = User2Light;
